export default __webpack_public_path__ + "static/media/filler.d77bc6c0.png";